export function requestHiddenFrame(src: string): Promise<string> {
    /*
        эта функция делает запрос по указанному адресу через спрятанный Iframe
        иногда это необходимо для обхода CORS (например, в случае установки куки на
        морде Яндекса) как в задаче https://st.yandex-team.ru/DIRECT-85497
    */
    const frame: HTMLIFrameElement = window.document.createElement('iframe');

    const cleanup = (): number => {
        return window.setTimeout(function(): HTMLIFrameElement {
            return window.document.body.removeChild(frame);
        });
    };

    return new Promise(
        (resolve, reject): void => {
            const onLoad: EventListener = (event: Event): void => {
                cleanup();
                const currentTarget = event.currentTarget as HTMLObjectElement;

                try {
                    if (!currentTarget.contentDocument) {
                        throw new Error();
                    }

                    resolve(currentTarget.contentDocument.body.innerText);
                } catch (e) {
                    reject();
                }
            };

            const onError = (): void => {
                cleanup();
                reject();
            };

            frame.onload = onLoad;
            frame.onerror = onError;
            frame.src = src;
            frame.setAttribute('style', 'display:none');
            window.document.body.appendChild(frame);
        }
    );
}
